// import store from '@/store';
import router from '../../router';
import httpService from '@/service/http-service';
const transactionType = [
  {
    label: '销售合同',
    value: 'SALES_CONTRACT',
    fileType: 'sales_file',
    containChild: [
      '/salePurchase/singleSale',
      '/salePurchase/singleSaleEdit',
      '/salePurchase/yearSale',
      '/salePurchase/yearSaleEdit',
      '/salePurchase/monthSale',
      '/salePurchase/monthSaleEdit',
      '/salePurchase/saleIntent',
      '/salePurchase/saleIntentEdit',
      '/salePurchase/purchaseIntent',
    ],
  },
  {
    label: '采购合同',
    value: 'PURCHASE_CONTRACT',
    fileType: 'purchase_file',
    containChild: [
      '/salePurchase/yearPurchase',
      '/salePurchase/yearPurchaseEdit',
      '/salePurchase/monthPurchase',
      '/salePurchase/monthPurchaseEdit',
      '/salePurchase/singlePurchaseContract',
      '/salePurchase/singlePurchaseContractEdit',
      '/salePurchase/purchaseIntentEdit',
    ],
  },
  {
    label: '项目立项',
    value: 'PROJECT_INITIATION_FILE',
    fileType: 'project_file',
    containChild: ['/projectInitiation/projectCreate'],
  },
  {
    label: '多式联运项目立项',
    value: 'INTERMODALITY_PROJECT_INITIATION_FILE',
    fileType: 'intermodality_project_file',
    containChild: ['/intermodality/projectDetail'],
  },
];
// const list = {
//   sales_file: [
//     {label: "合同原件", value: "originalContract"},
//     {label: "入库明细单", value: "receiptDetails"},
//   ],
//   purchase_file: [
//     {label: "合同原件", value: "originalContract"},
//     {label: "入库明细单", value: "receiptDetails"},
//   ]
// }
async function getDict(type, suffix = '_FILETYPE') {
  return await httpService.post('/maindata/dict/getAllDictMap', { dictType: type + suffix });
}
export async function findFileType() {
  let transactionList = null;
  let res = await httpService.post('/maindata/dict/getAllDictMap', {
    dictType: 'transaction_type',
  });
  transactionList = res.data.data;

  let currentRoute = router.currentRoute.path;
  let type = null;
  let fileList = [];
  for (let i = 0; i < transactionType.length; i++) {
    if (transactionType[i].containChild.includes(currentRoute)) {
      if (
        transactionList[transactionType[i].value] &&
        transactionList[transactionType[i].value].enable
      ) {
        await getDict(transactionType[i].value).then((res) => {
          fileList = res.data.data;
          type = transactionType[i].value;
        });
      } else {
        if (transactionType[i].value == 'PROJECT_INITIATION_FILE') {
          await getDict(transactionType[i].value, '').then((res) => {
            fileList = res.data.data;
            type = transactionType[i].value;
          });
        } else {
          type = null;
          fileList = [];
        }
      }
      break;
    } else {
      type = null;
      fileList = [];
    }
  }
  return { type, fileList };
}
